<template>
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" md="6" class="text-center">
            <template v-if="error">
              <v-alert type="error" outlined class="mb-4">{{ error }}</v-alert>
              <p class="text-body-1">Open this study using the link from Prolific (it includes your participant ID).</p>
            </template>
            <template v-else>
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              <p class="mt-4 text-h6">Loading study...</p>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';
import { parseProlificParams, collectDeviceInfo, routeForPhase } from '@/utils/prolific';

export default {
  name: 'ProlificEntry',
  title: 'Prolific Study Entry',
  data() {
    return { error: null };
  },
  async created() {
    const params = parseProlificParams(this.$route.query);

    // No login — identity comes from Prolific URL
    if (!params.PROLIFIC_PID) {
      this.error = 'Missing PROLIFIC_PID in the URL.';
      return;
    }
    // SESSION_ID is normally from Prolific; synthesize for local inspection if absent
    if (!params.SESSION_ID) {
      params.SESSION_ID = `local-${params.PROLIFIC_PID}-${Date.now()}`;
    }

    try {
      const resp = await fetch(`${config.API_BASE_URL}/prolific/start/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...params,
          device_info: collectDeviceInfo(),
        }),
      });
      const session = await resp.json();
      if (!resp.ok) {
        this.error = session.error || 'Could not start study session.';
        return;
      }

      if (params.graph_id && session.phase === 'main') {
        this.$router.replace(`/prolific/study/${session.id}/label/${params.graph_id}`);
        return;
      }

      this.$router.replace(routeForPhase(session));
    } catch (err) {
      console.error(err);
      this.error = 'Network error starting the study. Please try again.';
    }
  },
};
</script>
